import { render, staticRenderFns } from "./hero_widget.vue?vue&type=template&id=e143200a&scoped=true&lang=pug"
import script from "./hero_widget.vue?vue&type=script&lang=js"
export * from "./hero_widget.vue?vue&type=script&lang=js"
import style0 from "./hero_widget.vue?vue&type=style&index=0&id=e143200a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e143200a",
  null
  
)

export default component.exports